import './comp_map_marker.css'
import React, { useEffect, useRef } from 'react';

export const Comp_Map_Marker = (props) => {
 const mapRef= useRef(null);

 // 1) Make sure your CSS sets the map container size (example):
// #map { width: 100%; height: 500px; } 
// or set mapRef.current.style.height = '500px' before creating the map.

const mapMarkerNew_NN = ({
  restrictToIndia = true,
  grayOutOutside = false
} = {}) => {
  if (!props.qlcList || props.qlcList.length === 0) return;

  // Expanded India bounds (includes Lakshadweep, Andaman & Nicobar)
  // SW: near Nicobar / Lakshadweep area, NE: Himalayan east
  const indiaSw = new window.google.maps.LatLng(5.5, 66.5);   // slightly more west/south
  const indiaNe = new window.google.maps.LatLng(38.5, 98.5);  // slightly more north/east
  const indiaBounds = new window.google.maps.LatLngBounds(indiaSw, indiaNe);

  // Ensure the map container has size (common problem when map appears half)
  if (mapRef && mapRef.current) {
    const rect = mapRef.current.getBoundingClientRect();
    if (rect.height === 0 || rect.width === 0) {
      // If zero, set a default height so Google can render correctly
      mapRef.current.style.height = mapRef.current.style.height || '500px';
    }
  }

  const mapOptions = {
    center: new window.google.maps.LatLng(22.9764, 76.0555),
    zoom: 3,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    restriction: {
      latLngBounds: indiaBounds,
      strictBounds: !!restrictToIndia
    },
    minZoom: 2,
    maxZoom: 12
  };

  const map = new window.google.maps.Map(mapRef.current, mapOptions);

  // Fix: ensure map resizes and fitBounds after the container is painted
  //  - trigger resize (useful if container changed size or was hidden)
  setTimeout(() => {
    try {
      window.google.maps.event.trigger(map, 'resize');
    } catch (e) {
      // no-op
    }
  }, 50);

  // Fit bounds after the map becomes idle so it uses correct container size
  window.google.maps.event.addListenerOnce(map, 'idle', () => {
    try {
      map.fitBounds(indiaBounds);
    } catch (e) {
      console.warn('fitBounds failed:', e);
      map.setCenter(new window.google.maps.LatLng(22.9764, 76.0555));
      map.setZoom(3);
    }
  });

  const infoWindows = [];
  const closeAllInfoWindows = () => infoWindows.forEach((iw) => iw.close());

  // Only add the dim polygon if explicitly requested and be careful with zIndex
  if (grayOutOutside) {
    const outerCoords = [
      { lat: 85, lng: -180 },
      { lat: 85, lng: 180 },
      { lat: -85, lng: 180 },
      { lat: -85, lng: -180 }
    ];
    const ne = indiaBounds.getNorthEast();
    const sw = indiaBounds.getSouthWest();
    const innerCoords = [
      { lat: sw.lat(), lng: sw.lng() },
      { lat: sw.lat(), lng: ne.lng() },
      { lat: ne.lat(), lng: ne.lng() },
      { lat: ne.lat(), lng: sw.lng() }
    ];
    const dimPolygon = new window.google.maps.Polygon({
      paths: [outerCoords, innerCoords],
      strokeOpacity: 0,
      strokeWeight: 0,
      fillOpacity: 0.45,
      clickable: false,
      zIndex: 1 // low zIndex so markers & controls appear above it
    });
    dimPolygon.setMap(map);
  }

  // Add markers (skip invalid coordinates)
  props.qlcList.forEach((item) => {
    if (!item.gps_lat_log) return;
    const mapGps = item.gps_lat_log.split(',');
    if (mapGps.length !== 2) return;

    const vLat = parseFloat(mapGps[0]);
    const vLng = parseFloat(mapGps[1]);
    if (Number.isNaN(vLat) || Number.isNaN(vLng)) {
      console.warn('Invalid GPS for item', item);
      return;
    }

    // Skip markers outside India bounds (optional)
    if (!indiaBounds.contains(new window.google.maps.LatLng(vLat, vLng))) {
      // If you want to show them, comment out the following line.
      return;
    }

    const infoWindow = new window.google.maps.InfoWindow({
      content: `<div class="info-window">
                  <div class="student-name"><strong>Name: </strong>${item.business_name}</div>
                  <div class="student-details"><strong>ID:</strong> ${item.dealer_code}</div>
                  <div class="student-details"><strong>Address: </strong>${item.address || ''}, ${item.city_name || ''}, ${item.pincode || ''}, ${item.state_name || ''}</div>
                  <div class="student-details"><strong>Last Activity: </strong>${item.fmt_last_oil_change || ''}</div>
                  <div class="student-details"><strong>Status: </strong><span class="badge rounded-pill bg-${item.oil_change_status === 'Not Active' ? 'danger' : 'success'}">${item.oil_change_status || ''}</span></div>
                  <div class="student-details"><strong>Workshop: </strong><a href="${"../workshops_performance/"+btoa(item.id)}">View Details</a></div>
                </div>`
    });
    infoWindows.push(infoWindow);

    const iconMarks = item.oil_change_status === 'Not Active'
      ? 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
      : 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';

    const marker = new window.google.maps.Marker({
      position: { lat: vLat, lng: vLng },
      map,
      title: item.business_name || '',
      icon: iconMarks,
      zIndex: 2 // above dim polygon
    });

    marker.addListener('click', () => {
      closeAllInfoWindows();
      infoWindow.open(map, marker);
    });
  });

  // Keep user from zooming out too far
  map.addListener('zoom_changed', () => {
    if (map.getZoom() < 4) map.setZoom(4);
  });
};



 const mapMarkerNew = () => {
  if (props.qlcList && props.qlcList.length > 0) {
    // India bounding box (approx)
    const indiaSw = new window.google.maps.LatLng(6.5546079, 68.1113787);   // southwest
    const indiaNe = new window.google.maps.LatLng(35.6745457, 97.395561);   // northeast
    const indiaBounds = new window.google.maps.LatLngBounds(indiaSw, indiaNe);

    const mapOptions = {
      // initial center / zoom are optional if you call fitBounds below
      center: new window.google.maps.LatLng(22.9764, 76.0555),
      zoom: 10,
      mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      // Restrict map to India bounds. Set strictBounds: true to prevent panning out.
      restriction: {
        latLngBounds: indiaBounds,
        strictBounds: false // set to true if you want to prevent user panning outside entirely
      },
      // optional: limit zoom range
      minZoom: 4,
      maxZoom: 30,
      // optional: reduce default UI if you want
      // gestureHandling: 'auto'
    };

    const map = new window.google.maps.Map(mapRef.current, mapOptions);

    // Make the initial viewport cover India nicely
    map.fitBounds(indiaBounds);

    const infoWindows = [];

    const closeAllInfoWindows = () => {
      infoWindows.forEach((infowindow) => infowindow.close());
    };

    props.qlcList.forEach((item) => {
      if (item.gps_lat_log !== "") {
        const mapGps = item.gps_lat_log.split(",");
        if (mapGps.length === 2) {
          const vLat = parseFloat(mapGps[0]);
          const vLng = parseFloat(mapGps[1]);

          // skip markers outside India bounds (optional)
          if (!indiaBounds.contains(new window.google.maps.LatLng(vLat, vLng))) {
            return;
          }

          const infoWindow = new window.google.maps.InfoWindow({
            content: `<div class="info-window">
                        <div class="student-name"><strong>Name: </strong>${item.business_name}</div>
                        <div class="student-details"><strong>ID:</strong> ${item.dealer_code}</div>
                        <div class="student-details"><strong>Address: </strong>${item.address+", "+item.city_name+", "+item.pincode+", "+item.state_name}</div>
                        <div class="student-details"><strong>Last Activity: </strong>${item.fmt_last_oil_change}</div>
                        <div class="student-details"><strong>Status: </strong><span class="badge rounded-pill bg-${item.oil_change_status === 'Not Active' ? 'danger' : 'success'}">${item.oil_change_status}</span></div>
                        <div class="student-details"><strong>Workshop: </strong><a href="${"../workshops_performance/"+btoa(item.id)}">${"View Details"}</a></div>
                      </div>`
          });
          infoWindows.push(infoWindow);

          const iconMarks =
            item.oil_change_status === "Not Active"
              ? 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
              : 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';

          const marker = new window.google.maps.Marker({
            position: { lat: vLat, lng: vLng },
            map,
            title: item.name,
            icon: iconMarks,
          });

          marker.addListener('click', () => {
            closeAllInfoWindows();
            infoWindow.open(map, marker);
          });
        }
      }
    });
  }
};

 const mapMarkerNew1=()=>{
  if (props.qlcList && props.qlcList.length > 0) {
    const mapOptions = {
      center: new window.google.maps.LatLng(22.9764, 76.0555),
      zoom: 4,
      mapTypeId: window.google.maps.MapTypeId.ROADMAP
    };
    const map = new window.google.maps.Map(mapRef.current, mapOptions);
    const infoWindows = [];

    // Function to close all info windows
    const closeAllInfoWindows=()=> {
      //alert(infoWindows.length);
      infoWindows.forEach((infowindow) => infowindow.close());
    }

    props.qlcList.forEach((item) => {
      if(item.gps_lat_log!==""){
        let mapGps=item.gps_lat_log.split(',');
      
        if(mapGps.length===2){
          let vLat = parseFloat(mapGps[0]);
          let vLng = parseFloat(mapGps[1]);

          const infoWindow = new window.google.maps.InfoWindow({
            content: `<div class="info-window">
                        <div class="student-name"><strong>Name: </strong>${item.business_name}</div>
                        <div class="student-details"><strong>ID:</strong> ${item.dealer_code}</div>
                        <div class="student-details"><strong>Address: </strong>${item.address+", "+item.city_name+", "+item.pincode+", "+item.state_name}</div>
                        <div class="student-details"><strong>Last Activity: </strong>${item.fmt_last_oil_change}</div>
                        <div class="student-details"><strong>Status: </strong><span class="badge rounded-pill bg-${item.oil_change_status === 'Not Active' ? 'danger' : 'success'}">${item.oil_change_status}</span></div>
                        <div class="student-details"><strong>Workshop: </strong><a href="${"../workshops_performance/"+btoa(item.id)}">${"View Details"}</a></div>
    
                      </div>`
          });
          infoWindows.push(infoWindow);

        
        

          if(item.oil_change_status==="Not Active"){
           let iconMarks='http://maps.google.com/mapfiles/ms/icons/red-dot.png';
           const marker = new window.google.maps.Marker({
              position: { lat: vLat, lng: vLng },
              map: map,
              title: item.name,
              icon: iconMarks,
              // opacity:0.8
            });

            
      marker.addListener('click', () => {
        //alert(infoWindows.length);
        closeAllInfoWindows(); // Close others
        infoWindow.open(map, marker);
       
      });

          }else{
           let iconMarks='http://maps.google.com/mapfiles/ms/icons/green-dot.png';
           const marker = new window.google.maps.Marker({
              position: { lat: vLat, lng: vLng },
              map: map,
              title: item.name,
              icon: iconMarks,
            });

            
      marker.addListener('click', () => {
        //alert(infoWindows.length);
        closeAllInfoWindows(); // Close others
        infoWindow.open(map, marker);
       
      });
          }
  }//condition for accurate GPS

    }//condition for blank gps

    });
  }
   
 }

 useEffect(()=>{
  

  //markMap();
if(props.qlcList.length>0){
  
  mapMarkerNew();
}
//alert(props.qlcList.length);
//mapMarkerNew();

 },[props.qlcList]);

  return (
    <div style={{"width":"100%"}} class="map-div" ref={mapRef} ></div>
  );
};

export default Comp_Map_Marker;
